import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/face-reshaping"
    exact
    path="/business/showcase/face-reshaping"
    component={AsyncPage}
  />,
];
